import '@trp-beacon-ui-kit/foundation/style-tokens/css/variables.css';
import '@trp-beacon-ui-kit/foundation/fonts/fonts.css';
import '@trp-beacon-ui-kit/foundation/css/style.css';
import '@trp-beacon-ui-kit/foundation/style-tokens/css/theme-trp.css';

import React from 'react';
import { BrowserRouter as Router } from 'react-router';
import { Box, setAppCode } from '@trp-individual-investor-adv-svc/ii-prosp-components';

import Loading from '../containers/Loading';
import YodleeLinkAccountView from '../containers/YodleeLinkAccountView';
import connectWithMGPStore from '../reducers/connectWithMGPStore';
import AppContextAPI from './AppContextAPI';
import PsRoutes from './Routes';
import { UserContextCreator } from '../actions/ContextCreators';
import SessionTimer from './modals/SessionTimer';
import { log } from '../Utils';
import { profile } from './shared/Profile';
import AdviceFooterImpl from './shared/AdviceFooter/AdviceFooterImpl';
import BlueBanner from './navbars/BlueBanner';
import SessionLogoutLoader from './modals/SessionLogoutLoader';
import ServiceErrorCard from './shared/ServiceErrorCard';

setAppCode('ps');

const LoadingWrapper = () => (
    <Box sx={{ height: '80vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <Loading />
    </Box>
);

const AppMapper = ({ state, indexState, dispatch }) => {
    const profiler = profile(state);

    if (
        state?.isError?.error &&
        !state.isLoading &&
        !window.location.pathname.includes('/usis/advice/fps/yodlee-link-account')
    ) {
        return (
            <UserContextCreator.Provider value={{ state, dispatch, profiler }}>
                <Router basename={'/usis/advice/fps/'}>
                    <BlueBanner state={state} profile={profiler} dispatch={dispatch} />
                    <ServiceErrorCard showButton />
                    <SessionLogoutLoader />
                    <SessionTimer state={state} />
                    <AdviceFooterImpl noPt />
                </Router>
            </UserContextCreator.Provider>
        );
    }

    if (window.location.pathname.includes('/usis/advice/fps/yodlee-link-account')) {
        const navDiv = document.getElementById('nav-container');
        navDiv.style.display = 'none';
        return <YodleeLinkAccountView indexState={indexState} />;
    }

    if (state.isLoading) {
        return <LoadingWrapper />;
    }

    return (
        <UserContextCreator.Provider value={{ state, dispatch, profiler }}>
            <PsRoutes indexState={indexState} />
        </UserContextCreator.Provider>
    );
};

function App({ indexState }) {
    const [state, dispatch] = AppContextAPI(indexState);
    const getLogoutButton = document.querySelectorAll('ii-login-btn')[0];
    const keysToRemove = ['emailInv', 'invitePinNumber', 'joiningRasHH'];
    if (getLogoutButton) {
        getLogoutButton?.addEventListener('click', function () {
            keysToRemove.forEach((k) => localStorage.removeItem(k));
            keysToRemove.forEach((k) => sessionStorage.removeItem(k));
        });
    }
    log(console.log('STATE', state));

    return (
        <div className="mgpWrapper beacon-theme-modern-outlook">
            <AppMapper state={state} indexState={indexState} dispatch={dispatch} />
        </div>
    );
}

export default connectWithMGPStore(App);
